// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3OLyW","rootSmall":"AddTileButton_rootSmall__tg3DJ"};